export type ResolvedFn<T> = (val: T) => T | Promise<T>;

export type RejectedFn = (val: any) => any;

export interface Interceptor<T> {
  resolved: ResolvedFn<T>
  rejected?: RejectedFn
}

/**
 * login 方法拦截器传入参数
 */
export interface InterceptorLoginConfig {
  /** 端外登录类型 */
  webLoginMode?: WebLoginMode;
}

export enum WebLoginMode {
  /** 取消登录 */
  CANCEL = 'CANCEL',
  WX = 'WX',
  QQ = 'QQ',
}
